export default __webpack_public_path__ + "static/html-2543178fdef4a14935e070074a8026cc.png";